@if (items().length === 0) {
  <div class="text-center py-8">
    <p>{{ emptyMessage() }}</p>
  </div>
} @else {
  @if (showCard()) {
    <p-card>
      <ng-container [ngTemplateOutlet]="dataViewTemplate"></ng-container>
    </p-card>
  } @else {
    <ng-container [ngTemplateOutlet]="dataViewTemplate"></ng-container>
  }
}

<ng-template #dataViewTemplate>
  <p-data-view
    [value]="items()"
    [paginator]="showPaginator()"
    [rows]="rows()"
    [first]="0"
    layout="grid"
  >
    <ng-template #grid let-items>
      <div class="grid gap-6" [class]="gridCols()">
        @for (item of items; track item) {
          <ng-container
            [ngTemplateOutlet]="itemTemplate()"
            [ngTemplateOutletContext]="{$implicit: item}"
          ></ng-container>
        }
      </div>
    </ng-template>
  </p-data-view>
</ng-template>
